import { DateTime } from 'luxon';

export const isTimeRangeValid = value =>
  Array.isArray(value) &&
  value.length === 2 &&
  value.every(date => date instanceof DateTime && date.isValid) &&
  value[0] <= value[1];
